import { getEnv, types } from 'mobx-state-tree';
import Axios, { AxiosResponse } from 'axios';
import type { IResponse } from './IResponse';
import { flow } from 'mobx';

export const ApiRequest = types.model(
  'ApiRequest',
  {})
  .actions(self => ({
    createHeaderOption: flow(function* () {
      const token = yield getEnv(self).bearerTokenProvider.getToken();
      return {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      };
    })
  }))
  .actions(self => ({
    get: flow(function* <T>(url: string) {
      const res = yield Axios.get<IResponse<T>>(url, yield self.createHeaderOption());
      return (res as unknown as AxiosResponse<IResponse<T>>).data;
    }),
    post: flow(function* <T>(url: string, data: unknown) {
      const res = yield Axios.post(url, data, yield self.createHeaderOption());
      return (res as unknown as AxiosResponse<IResponse<T>>).data;
    })
  }));


// export interface IHeaderProvider extends Instance<typeof ApiRequest> {
// }
